import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import NumberInput from '../../../../Common/numberInput';

class Measurement extends Component{
  shouldComponentUpdate = (nextProps) => {
    return nextProps.measurement!==this.props.measurement
  };
  render()  {
    const { measurement: { type, length, depth, area, amount },
      selectpickerChildren, updateMeasurement } = this.props;
    return (
      <div className="row" style={styles.container}>
        <div style={styles.firstColumn} className="col-xs-3">
          <select
            value={type}
            style={styles.select}
            onChange={(evt) => updateMeasurement('type', evt.target.value)}>
            {selectpickerChildren}
          </select>
        </div>
        <div style={styles.secondColumn}>
          <NumberInput
            onChange={(val) => updateMeasurement('amount', val)}
            value={amount}
            shouldNotCallOnChangeOnMount={true}
          />
        </div>
        <div style={styles.thirdColumn}>
          <NumberInput
            onChange={(val) => updateMeasurement('length', val)}
            value={length}
            shouldNotCallOnChangeOnMount={true}
          />
        </div>
        <div style={styles.forthColumn}>
          <NumberInput
            onChange={(val) => updateMeasurement('depth', val)}
            value={depth}
            shouldNotCallOnChangeOnMount={true}
          />
        </div>
        <div style={styles.fifthColumn}>
          <input
            style={styles.input}
            value={area}
            onChange={(evt) => updateMeasurement('area', evt.target.value)}
          />
        </div>
      </div>
    );
  }
}

var styles = {
  container: {
    margin: '0 0 6px 0'
  },
  select: {
    '-webkit-appearance': 'none',
    '-moz-appearance':    'none',
    '-webkit-border-radius': '0px',
    boxShadow: '0 1px 2px rgba(0,0,0,0.2) inset, 0 -1px 0 rgba(0,0,0,0.05) inset',
    backgroundColor: 'white',
    cursor: 'pointer',
    width:' 100%',
    height: '35px',
    border: 'none',
    padding: '5px'
  },
  firstColumn: {
    width: '21%',
    paddingRight: '12px',
    paddingLeft: '0',
    float: 'left'
  },
  secondColumn: {
    width: '12%',
    padding: '0 12px',
    float: 'left',
    textAlign: 'right'
  },
  thirdColumn: {
    width: '20%',
    padding: '0 12px',
    float: 'left',
    textAlign: 'right'
  },
  forthColumn: {
    width: '12%',
    padding: '0 12px',
    float: 'left',
    textAlign: 'right'
  },
  fifthColumn: {
    width: '35%',
    padding: '0 12px',
    float: 'left'
  },
  input: {
    '-webkit-appearance': 'none',  
    border: 'none',
    display: 'block',
  }
}
  Measurement.propTypes = {
    measurement: PropTypes.shape({
      type: PropTypes.string.isRequired,
      amount: PropTypes.number.isRequired,
      length: PropTypes.number.isRequired,
      depth: PropTypes.number.isRequired,
      area: PropTypes.string
    }),
    selectpickerChildren: PropTypes.array.isRequired,
    updateMeasurement: PropTypes.func.isRequired
  };
export default Radium(Measurement)


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/DailyReport/Measurements/measurement.jsx